module.exports = __webpack_public_path__ + "static/media/desc-tt.4cb36668.png";